<template>
<div>
    <div class="login_wrap">
        
        <dl>
            <dt>회원가입 완료!</dt>
            <dd>
                소셜 계정을 등록해서 간편하게 로그인 해보세요.
            </dd>
        </dl>

        <ul class="social_login">
            <li>
                <a @click="kakaoOAuth();"><img :src="$store.state.resource.imgIconKakao">카카오 계정 연동하기</a>
            </li>
            <li>
                <a @click="googleOAuth();"><img :src="$store.state.resource.imgIconGoogle">구글 계정 연동하기</a>
            </li>
            <li v-if="agentCheck == Const.SOCIAL.IOS">
                <a @click="appleOAuth();"><img :src="$store.state.resource.imgIconApple">Apple 계정 연동하기</a>
            </li>
        </ul>
    </div>
    
    <div class="btn_box_fixed" style="text-align:center">
        <!--default_btn1-->
        <router-link to="/join/main" class="under_line_btn">다음에 할게요</router-link>
    </div>
</div>

</template>

<script>
import { SocialMixin } from '../../mixins/SocialMixin';

export default {
    name:'JoinSocial',
    mixins:[SocialMixin],

    created() {
        this.$store.commit('SHOW_ONLOAD');
    },
    data() {
        return {
            itemWrite: this.$store.state.auth.itemWrite,
        }
    },
    methods: {      
    },
}
</script>

<style lang="scss" scoped>

</style>